import { render, staticRenderFns } from "./instockManage.vue?vue&type=template&id=24974abf&scoped=true&"
import script from "./instockManage.vue?vue&type=script&lang=js&"
export * from "./instockManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24974abf",
  null
  
)

export default component.exports